export function buildPagination(charactersPerPage,total){
    //Pagination build
    //this function take the params charactersPerPage and total. 
    //charactersPerPage meainng how many characters we're showing. That way each button of the pagination know how
    //much to offset the API call by. The '-1' below is bc the pagination starts with 1 and not 0. 
    //when the user clicks pagination link '2', it has to make the api call with an offset of 1 page. and so on. 
    //fuck i hope that makes sense later when i come back to this.

    //oh great. i think if this numer (links) is too low the pagination isnt built. 
    //so if there is no page2, no pagination. Thagt was a nice surprise
    var links = Math.floor(total / charactersPerPage);
    //links returns a page count staing with zero. 
    //we have to add one to it bc below we start with 1 in the loops
    links = links + 1;
    var linkBuildArray = [];
    

    //get the current page from the url
    var url = window.location.href;
    var currentPage = Number(url.split('/page')[1]);

    //this is actually 9 since the loops will start with 0
    var totalButtonAmount = 8;
    
    //console.log("TOTAL: " + total);
    //console.log("LINKS: " + links);

    //PAGINATION HIGHLIGHTING all done in the pagination display files. (pagination.js and comicPagination.js)
    //once we have the current page, we can build the pagination around it
    
    //if the content needs less then 8 pagination links, 
    //only build the array with however many links are needed
    if( (currentPage - 4) <= 0 && links < 8){
        //console.log(currentPage + " is LESS than 4 AND LESS than 8")
        for(var i = 1; i <= links; i++){
            var linkNumber = i;
            //console.log("linkNumber: " + linkNumber);
            if(i === 1){
                var offset = 0;
            }
            else{
                var offset = (linkNumber -1) * charactersPerPage;  
            }
            linkBuildArray.push([linkNumber,offset]);
        }
        
    }   
    //else if the current page is less than 4 but has more than 8 pagination links, 
    //start at 1 and render all 8
    else if( (currentPage - 4) <= 0 && total > 8){
        //console.log(currentPage + " is LESS than 4")
        for(var i = 1; i <= totalButtonAmount; i++){
            var linkNumber = i;
            if(i === 1){
                var offset = 0;
            }
            else{
                var offset = (linkNumber -1) * charactersPerPage;  
            }
            linkBuildArray.push([linkNumber,offset]);
        } 
        //links will always be the last page since its the result of diving the total by items per page
        var lastOffset = (links - 1) * charactersPerPage;
        linkBuildArray.push(["...",lastOffset]);
        linkBuildArray.push([links,lastOffset]);
    }
    //else if the page is greater than 4 and has more pages than 8, render the current page is the middle
    else if( (Number(currentPage) - 4) > 0 && (Number(currentPage) + 4) <= Number(links)){
        //console.log(currentPage + " is MORE than 4 and theres way more to go")
        //weird. need to use Number() bc otherwise its returning a string? wtf?!
        var startNumber = Number(currentPage) - Number(4);
        var endNumber = Number(currentPage) + Number(4);
        // console.log("START NUMBER: " + startNumber);
        // console.log("CURRENT PAGE: " + currentPage);
        // console.log("END NUMBER: " + endNumber);
        for(var i = startNumber; i <= endNumber; i++){
            var linkNumber = i;
            if(i === 1){
                var offset = 0;
            }
            else{
                var offset = (linkNumber -1) * charactersPerPage;  
            }
            linkBuildArray.push([linkNumber,offset]);
        }
        //links will always be the last page since its the result of diving the total by items per page
        var lastOffset = (links - 1) * charactersPerPage;
        linkBuildArray.push(["...",lastOffset]);
        linkBuildArray.push([links,lastOffset]);
        //inject page1 button at the start of the array if the current page is 7 or above. 
        //7 is the lowest number where we need 'page 1' bc of the way we have the numbers set up
        //makes no sense to show it if 1 or 2 is still displayed. 7 is where 3 is the first link
        if(currentPage >= 7){
            linkBuildArray.unshift(["...",0]);
            linkBuildArray.unshift([1,0]);
        }
    }
    //else if the page is greater than 4 and has LESS pages left than 8, only render whatever is needed after
    else if( (currentPage - 4) > 0 && (currentPage + 4) >= Number(links)){
        //console.log(currentPage + " is MORE than 4")
        var startNumber = Number(currentPage) - Number(4);
        var endNumber = Number(links);

        for(var i = startNumber; i <= endNumber; i++){
            var linkNumber = i;
            if(i === 1){
                var offset = 0;
            }
            else{
                var offset = (linkNumber -1) * charactersPerPage;  
            }
            linkBuildArray.push([linkNumber,offset]);
        } 
    }

    //if the page has JUST enough characters for a full page, the pagination displays 1 link. which links to the current page.
    //which is dumb. So this tells it not to render the pagination at all if thats the case
    if(linkBuildArray.length === 1){
        linkBuildArray = [];
    }
    return linkBuildArray;








}


// WEBPACK FOOTER //
// ./src/components/includes/buildPagination.js